import { render, staticRenderFns } from "./ExerciseFormModal.vue?vue&type=template&id=63ef2004&scoped=true"
import script from "./ExerciseFormModal.vue?vue&type=script&lang=js"
export * from "./ExerciseFormModal.vue?vue&type=script&lang=js"
import style0 from "./ExerciseFormModal.vue?vue&type=style&index=0&id=63ef2004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef2004",
  null
  
)

export default component.exports